import { render, staticRenderFns } from "./CustomerWsuDetail.vue?vue&type=template&id=ea1abcce&scoped=true&"
import script from "./CustomerWsuDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerWsuDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1abcce",
  null
  
)

export default component.exports